import React from "react";

function KeyFeatures({ item }) {
  const groupedFeatures = item?.reduce((acc, feature) => {
    const group = feature.group || "Other";

    if (!acc[group]) {
      acc[group] = [];
    }

    acc[group].push(feature);

    return acc;
  }, {});

  return (
    <div className="item">
      <p className="key-title mb-2">KEY FEATURES OF PRODUCT</p>

      {Object.entries(groupedFeatures).map(([group, features]) => (
        <div key={group} className="mb-3">
          <p className="key-subtitle mb-1">{group}</p>

          <ul>
            {features.map((feature) => (
              <li key={feature.key}>
                <b className="key-label">{feature.label}:</b> {feature.value}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default KeyFeatures;
